import FullWidthBarBreadcrumbs from '@/components/Breadcrumb/FullWidthBarBreadcrumbs';
import CenteredContentSection from '@/components/ContentSection/CenteredContentSection';
import { H3 } from '@/components/Element/Heading';
import MetaTags from '@/components/Head/MetaTags';
import IncentiveTable from '@/components/IncentiveTable/IncentiveTable';
import FullWidthStateForm from '@/components/LeadForm/FullWidthStateForm';
import VerticalLeadFormSection from '@/components/LeadForm/VerticalLeadFormSection';
import PurchaseOptionSection from '@/components/PurchaseOptionSection/PurchaseOptionSection';
import StatSection from '@/components/StatSection.tsx/StatSection';
import StateFAQ from '@/components/StateFAQ/StateFAQ';
import StateHeaderSection from '@/components/StateHeaderSection/StateHeaderSection';
import React from 'react';

const Page = () => {
  const incentives = [
    {
      incentive: 'Federal ITC - 30%',
      value:
        "Solar PV systems installed in 2022 - 2032 are eligible for a 30% tax credit. The credit can only be claimed by on the original installation of the solar equipment located at a residence of yours. You must also purchase it using cash or financing, but you're not leasing the system or paying a solar company for the electricity produced by the system.",
    },
    {
      incentive: 'Instant Rebate from EnergyPal',
      value:
        'EnergyPal secures group discounts by leveraging the depth of our network. We pass these savings onto homeowners every day!',
    },
    {
      incentive: 'BWL Solar Rebate',
      value:
        "Installer will submit rebate applications on the customer's behalf after installation. The customer signs a rebate application form and is mailed the payment from the utility. Paid to Installer Directly.",
    },
    {
      incentive: 'Net Metering',
      value:
        "Net Metering allows you to sell excess power back to the grid. In Missouri, regulated utilities including rural electric cooperatives are required to have net metering policies, but they don't have to pay the full retail price per kilowatt-hour.",
    },
  ];

  return (
    <article>
      <MetaTags
        title="Missouri's Home Solar Benefits: Incentives, Credits & Policies"
        description="Find available incentives, tax credits, and utility policies for home solar in Texas with EnergyPal. Switch to solar energy today and save."
      />
      <StateHeaderSection dark state="Missouri" />
      <StatSection stats={'Missouri'} />
      <FullWidthBarBreadcrumbs
        pages={[
          {
            name: 'Home Solar & Battery Installers Near Me',
            href: '/home-battery-solar-installers-near-me',
          },
          {
            name: 'Missouri Solar',
            href: '/home-battery-solar-installers-near-me/mo-missouri',
          },
        ]}
      />
      <CenteredContentSection>
        <H3>Missouri Solar</H3>
        <p>
          Missouri, situated in the heart of the United States, has been
          increasingly recognizing the potential of solar energy to address
          energy needs, stimulate economic growth, and reduce environmental
          impact. While it may not have the same level of solar irradiance as
          some sunnier states, technological advancements and supportive
          policies have enabled the growth of solar installations in the Show-Me
          State.
        </p>
        <p>
          If you&apos;re a Missouri resident considering solar adoption,
          it&apos;s important to familiarize yourself with key state programs.
          Let’s explore the benefits of home solar in Missouri and uncover the
          potential that lies in harnessing the sun&apos;s energy to power your
          home.
        </p>
        <p>
          Let&rsquo;s learn about some of those incentives, the utility policies
          associated with interconnection and setup, and special solar financing
          plans for solar panels and battery systems in Michigan.
        </p>
        <h4 className="text-4xl font-semibold text-center text-black mt-0">
          Incentive Programs, Tax Credits, and
        </h4>
        <h4 className="text-4xl font-semibold text-center text-black mb-6">
          Solar Rebates in Missouri
        </h4>
        <IncentiveTable
          heading1={'Incentive'}
          heading2={'Description'}
          data={incentives}
        />
        <FullWidthStateForm cid="z51qgpvrzugajuq9" state="Missouri" />
        <H3>Other Solar Energy Incentives</H3>
        <p>
          The US federal government helps residents and businesses pay for their
          solar systems. The federal investment tax credit (ITC) allows for a
          tax deduction of 30% of the cost of a solar system currently. Tax
          credits can be rolled over if you can&rsquo;t use the whole credit
          this year. The ITC cannot be claimed for solar leases or power
          purchase agreements (PPAs) where the third party financier takes the
          credits themselves, but that is typically baked into a reduced
          lease/PPA monthly for you.
        </p>
        <p>
          If you purchased a $20,000 system, your savings from the federal tax
          credit would look like this:
        </p>
        <p>
          <em>$20,000 X 0.30 = $6,000 savings</em>
        </p>
        <PurchaseOptionSection cid="z51qgpvrzugajuq9" state="Missouri" />
        <StateFAQ state="Missouri" />
      </CenteredContentSection>
      <VerticalLeadFormSection />
    </article>
  );
};

export default Page;
